import { Injectable, Inject } from '@angular/core';
import { APP_BASE_HREF } from "@angular/common";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from "rxjs";
import { globals } from 'src/app/shared/globals';
import { AlertService } from 'src/app/_alert';


@Injectable()
export class CoursewareService {
    myAppUrl: string = "";
    tempUrl: string = globals.REMOTEHOST + "/";

    constructor(private _http: HttpClient, @Inject(APP_BASE_HREF) private baseHref: string, private alertService: AlertService) {
        this.myAppUrl = baseHref;
    }

    getCourses(): Observable<any> {
        return this._http.get(this.tempUrl + 'courseware/indexa').pipe(catchError(this.handleError));
    }

    handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        try {
            if (error.error instanceof ErrorEvent) {
                // Client-side errors
                errorMessage = `Error: ${error.message}`;
            } else {
                // Server-side errors
                errorMessage = `Error communicating with the server.  Please refresh your page or try again later.`;
            }
            console.log("Error communicating with server.  Details " + errorMessage);
            if (this.alertService)
                this.alertService.error(errorMessage);
            else
                window.alert(errorMessage);
            return throwError(errorMessage);
        } catch (e) {
            console.log("Communications error " + error.message);
        }
    }

    getSettings(token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/settingsa?Token=' + token).pipe(catchError(this.handleError));;
    }

    updateMemberUser(token: string, firstName: string, lastName: string, email: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/UpdateMemberUserA?Token=' + token + "&FirstName=" + firstName + "&LastName=" + lastName + "&Email=" + email).pipe(catchError(this.handleError));;
    }

    updatePassword(token: string, password: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/UpdatePasswordA?Token=' + token + "&Password=" + password).pipe(catchError(this.handleError));;
    }

    closeAccount(token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/CloseAccountA?Token=' + token).pipe(catchError(this.handleError));
    }

    getCourseEntries(Id: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'courseware/entrya/' + Id).pipe(catchError(this.handleError));
    }

    getCourseQuiz(Id: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'courseware/getquiza/' + Id).pipe(catchError(this.handleError));;
    }

    getVideoCourseQuiz(Id: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videocourses/getquiza/' + Id).pipe(catchError(this.handleError));;
    }

    getShortVideos(): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videos/indexa').pipe(catchError(this.handleError));;
    }

    getVideocourses(Token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videocourses/indexa?Token=' + Token).pipe(catchError(this.handleError));;
    }

    getVideocoursesData(Token: string, Id: string): Observable<any> {
        if (!Token)
            return this._http.get<any>(this.tempUrl + 'videocourses/VideoCoursea/' + Id).pipe(catchError(this.handleError));;
        return this._http.get<any>(this.tempUrl + 'videocourses/VideoCoursea?ID=' + Id + "&Token=" + Token).pipe(catchError(this.handleError));;
    }

    getExam(Id: string, token: string): Observable<any> {
        // TODO - CHANGE TO POST
        return this._http.get<any>(this.tempUrl + 'videocourses/exama?Token=' + token + '&ID=' + Id).pipe(catchError(this.handleError));;
    }

    startExam(Id: string, token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videocourses/startexama?ID=' + Id + "&Token=" + token).pipe(catchError(this.handleError));;
    }

    submitQuestion(examId: string, questionId: string, answerId: string, token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videocourses/submitquestiona?argDigitalBadgeExamID=' + examId + "&argQuestionID=" + questionId + "&argAnswerID=" + answerId + "&Token=" + token).pipe(catchError(this.handleError));
    }

    skipQuestion(examId: string, questionId: string, token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videocourses/skipquestiona?argDigitalBadgeExamID=' + examId + "&argQuestionID=" + questionId + "&Token=" + token).pipe(catchError(this.handleError));
    }

    getVideocoursesModule(Alias: string, ParentId: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videocourses/EntryA?ID=' + Alias + "&destination=videos&parentId=" + ParentId).pipe(catchError(this.handleError));
    }

    ForgotPassword(email: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/ForgotPasswordA?Email=' + email).pipe(catchError(this.handleError));
    }

    ResetPassword(token: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/ResetPasswordA?id=' + token).pipe(catchError(this.handleError));
    }

    GetFeaturedContent(): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'home/IndexA').pipe(catchError(this.handleError));
    }

    ResetAndChangePassword(token: string, newPassword: string): Observable<any> {
        const resetPasswordPayload = {
            token: token,
            newPassword: newPassword
        }

        return this._http.post(this.tempUrl + 'account/ResetPasswordA', resetPasswordPayload, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        })
    }

    Login(email: string, password: string): Observable<any> {
        const loginPayload = {
            email: email,
            password: password
        }

        return this._http.post(this.tempUrl + 'account/logina', loginPayload, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        });
    }

    ContactUs(Email: string, Message: string, Comment: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'home/contacta?Email=' + Email + "&Message=" + Message + "&Comment=" + Comment).pipe(catchError(this.handleError));
    }

    Logout(Token: string): Observable<any> {
        return this._http.get(this.tempUrl + 'account/logouta').pipe(catchError(this.handleError));
    }

    getTableOfContents(): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'home/toca').pipe(catchError(this.handleError));
    }

    Register(Email: string, Password: string, FirstName: string, LastName: string, AcceptTerms: string): Observable<any> {
        const registerPayload = {
            email: Email,
            password: Password,
            firstName: FirstName,
            lastName: LastName,
            acceptTerms: AcceptTerms
        }

        return this._http.post<any>(this.tempUrl + 'account/completeregistera', registerPayload, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        })
    }

    CompleteRegistration(memberID: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'account/CompleteRegistrationA?memberID=' + memberID).pipe(catchError(this.handleError));
    }

    getBlogs(): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'blog/indexa').pipe(catchError(this.handleError));
    }

    getBlogEntry(Id: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'blog/posta/' + Id).pipe(catchError(this.handleError));
    }

    getShortVideoEntry(Id: string): Observable<any> {
        return this._http.get<any>(this.tempUrl + 'videos/entrya/' + Id).pipe(catchError(this.handleError));
    }

    getResearchIndex(searchString: string, lastConceptDisplayed: string): Observable<any> {
        let theURL = this.tempUrl + 'concept/Indexa?startingLetter=' + searchString;
        if (!searchString)
            theURL = this.tempUrl + 'concept/Indexa/';
        if (lastConceptDisplayed && searchString)
            theURL = this.tempUrl + 'concept/Indexa?startingLetter=' + searchString + "&lastConceptDisplayed=" + lastConceptDisplayed;
        if (lastConceptDisplayed && !searchString)
            theURL = this.tempUrl + 'concept/Indexa?lastConceptDisplayed=' + lastConceptDisplayed;
        return this._http.get<any>(theURL).pipe(catchError(this.handleError));
    }

    getResearchIndexAutocomplete(searchString: string): Observable<any> {
        let theURL = this.tempUrl + 'concept/AutocompleteLinks?term=' + searchString;
        if (!searchString)
            this.tempUrl + 'concept/AutocompleteLinks/';
        return this._http.get<string>(theURL).pipe(catchError(this.handleError));
    }
}
